'use strict'

tag = document.createElement('script')
tag.id = 'iframe-demo'
tag.src = 'https://www.youtube.com/iframe_api'
firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore tag, firstScriptTag
player = undefined
onYouTubeIframeAPIReady = ->
  player = new YT.Player('article-top-yt-player', {
    events:
      'onReady': onPlayerReady
    })
  # document.getElementById('wal-video-embed').className += ' otherclass'
  return

onPlayerReady = (event) ->
  
  if location.hash is '#/video' or location.hash is '#video'
    $('#video-embed-bg').fadeOut()
    player.playVideo()

  console.log(player.getDuration())

  $('#video-embed-bg').on 'click', ->
    $(@).fadeOut()
    # $(this).parent().attr('class', 'embed-responsive embed-responsive-16by9')
    player.playVideo()